import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { CumulativeReportSummary } from 'types/embedded/cumulativeReport';
import { formatCurrency } from 'utils';

type Props = {
  summaryColor?: string;
  valueKey: keyof CumulativeReportSummary;
  originalValueKey: keyof CumulativeReportSummary;
} & Omit<FunctionFieldProps, 'render'>;

export const CumulativeReportSummaryField = ({
  label,
  summaryColor,
  valueKey,
  originalValueKey,
}: Props) => {
  return (
    <FunctionField
      label={label}
      render={(record: CumulativeReportSummary) => {
        const isOriginalCurrency = record.merchantAccountCurrencyCode === record.currencyCode;

        return (
          <Stack direction="column">
            <Typography
              component="span"
              sx={{ color: summaryColor, textWrap: 'nowrap', fontSize: '14px' }}
            >
              {formatCurrency(Number(record[valueKey]))}
              <Typography component="span" fontWeight={500} variant="body2">
                {' '}
                {record.currencyCode}
              </Typography>
            </Typography>
            {!isOriginalCurrency && (
              <Typography
                component="span"
                style={{ color: 'text.disabled', textWrap: 'nowrap', fontSize: '14px' }}
              >
                {formatCurrency(Number(record[originalValueKey]))}
                <Typography component="span" fontWeight={500} variant="body2">
                  {' '}
                  {record.merchantAccountCurrencyCode}
                </Typography>
              </Typography>
            )}
          </Stack>
        );
      }}
    />
  );
};
